import { render, staticRenderFns } from "./followBtn.vue?vue&type=template&id=068507bf&scoped=true"
import script from "./followBtn.vue?vue&type=script&lang=js"
export * from "./followBtn.vue?vue&type=script&lang=js"
import style0 from "./followBtn.vue?vue&type=style&index=0&id=068507bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068507bf",
  null
  
)

export default component.exports